<!-- 下拉选择器组件分装 -->
<template>
  <div>
    <el-upload action="" :limit="1" :before-upload="beforeUploadListPic" class="avatar-uploader"
					:show-file-list="false">
					<p class="avatar" v-if="listPicUrl != ''">
						<img :src="$util.webRoot + listPicUrl" /><a class="close"
							@click.stop="delListPic()">×</a>
					</p>
					<i v-else class="el-icon-plus avatar-uploader-icon" style="padding-top: 2px;"></i>
				</el-upload>
  </div>
</template>
  
<script>
export default {
  name: "upload-single",
  props: ["url"],
  data() {
    return {
      listPicUrl:""
    }
  },
  watch: {
    url: {
      handler(newValue) {
        this.listPicUrl=newValue
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    handleCallBack() {
      this.$emit("callBack", this.listPicUrl);
    },
    beforeUploadListPic(file) {
			if (!this.checkUploadPic(file)) {
				return false;
			}
			let formData = new FormData();
			formData.append('file', file);//传文件
			this.$axios.post('/comm/uploadfile', formData).then(res => {
				if (res.data.status == 0) {
					this.listPicUrl = res.data.data.dbPath
          this.handleCallBack()
				}
				else {
					this.$message(res.data.msg);
				}
			})
			return false;
		},
		delListPic() {
			this.listPicUrl = "";
      this.handleCallBack()
		},
  },
}
</script>
  
<style scoped lang="scss">

</style>
  
  